// extracted by mini-css-extract-plugin
export default {"container":"WordsPractice_container__+-7+h","slider":"WordsPractice_slider__1VHpq","sliderTrack":"WordsPractice_sliderTrack__tTlNO","slide":"WordsPractice_slide__GMWzy"};